<template>
<div>
<ContentHeader title="Soru Listesi Hesaplamaları"  url="NewQuestionlistSameTypeCalculation" :show_button="true" icon="plus" buttontype="primary" label="Yeni Hesaplama Ekle"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<template v-if="items.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>
<template v-else>


 <div class="mt-4">
<ContentTable :data="items" :columns="columns" routename="QuestionlistSameTypeCalculation" deleteobjectname="questionlistsametypecalculation" @dataDeleted="getData" identifier_row_name="calculation_id"></ContentTable>
</div>

</template>






</template>


</div>	
</template>

<script>
import QuestionlistCalculationLine from "./QuestionlistCalculationLine"
export default {

  name: 'QuestionlistSameTypeCalculations',
  components:{QuestionlistCalculationLine},
  data () {
    return {
      items:[],
      loading:true,
      columns:[
        {
          type:"text",
          field:"name",
          header:"isim",
          hide_on_mobile:false,
        },
        {
          type:"date",
          field:"created_at",
          header:"eklenme_tarihi",
          hide_on_mobile:true,
        },
        ]
    }
  },
  computed:{
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
      let items = await this.generalApiGetWithoutLoader("questionlistsametypecalculations/"+this.$route.params.id)
      
      this.items = await items
      console.log(this.items)
      this.loading = await false
    }
  }
}
</script>

<style lang="css" scoped>
</style>